export default {
    "2": "https://docs.trustwillow.com/apiresponses/coachcategories2.json",
    "3": "https://docs.trustwillow.com/apiresponses/coachcategories3.json",
    "4": "https://docs.trustwillow.com/apiresponses/coachcategories4.json",
    "14": "https://docs.trustwillow.com/apiresponses/coachcategories14.json",
    "35": "https://docs.trustwillow.com/apiresponses/coachcategories35.json",
    "43": "https://docs.trustwillow.com/apiresponses/coachcategories43.json",
    "44": "https://docs.trustwillow.com/apiresponses/coachcategories44.json",
}